export const routesPath = {
  home: '/',
  sso: '/sso',
  notFound: '*',
  error: '/error',
  reader: '/reader',
  logout: '/logout',
  notFoundRoute: '/404',
  selectRole: '/select-role',
  qc: '/qc',
  qcTasks: '/qc/:id',
  qcQueries: '/qc/queries/:id',
  qcQuery: '/qc/queries/:id/query/:queryId',
  qcTaskInfo: '/qc/:id/:taskId/info',
  qcTaskDXA: '/qc/:id/:taskId/DXA',
  qcTaskQCT: '/qc/:id/:taskId/QCT',
  qcTaskViewer: '/qc/:id/:taskId/viewer',
  profile: '/profile',
  about: '/about',
  dashboard: '/dashboard',
  clinicalTrials: '/clinical-trials',
  clinicalTrial: '/clinical-trials/:id',
  clinicalTrialOverview: '/clinical-trials/:id/overview',
  clinicalTrialSubjectList: '/clinical-trials/:id/subject-list',
  clinicalTrialSubjectDetail: '/clinical-trials/:id/subject/:patientId',
  clinicalTrialGeneralInformation: '/clinical-trials/:id/general-information',
  clinicalTrialImagingLabels: '/clinical-trials/:id/imaging-labels',
  clinicalTrialVisits: '/clinical-trials/:id/visits',
  clinicalTrialReports: '/clinical-trials/:id/reports',
  clinicalTrialNotifications: '/clinical-trials/:id/notifications',
  clinicalTrialNotificationsConfiguration:
    '/clinical-trials/:id/notifications/configuration',
  clinicalTrialNotificationsHistory:
    '/clinical-trials/:id/notifications/history',
  clinicalTrialNotificationsSiteRecipients:
    '/clinical-trials/:id/notifications/recipients',
  clinicalTrialSites: '/clinical-trials/:id/sites',
  clinicalTrialTeam: '/clinical-trials/:id/team',
  clinicalTrialForms: '/clinical-trials/:id/forms',
  clinicalTrialFormsAssigned: '/clinical-trials/:id/forms/assigned',
  clinicalTrialFormsManagement: '/clinical-trials/:id/forms/management',
  readings: '/clinical-trials/:id/readings',
  readingInventory: '/clinical-trials/:id/readings/reading-inventory',
  taskDefinition: '/clinical-trials/:id/readings/task-definition',
  taskDefinitionForm: '/task-definition-form/:ctId/:taskId',
  sites: '/operations/sites',
  inventory: '/inventory',
  sponsors: '/inventory/sponsors',
  modalities: '/inventory/modalities',
  labels: '/inventory/labels',
  therapeuticArea: '/inventory/therapeutic-area',
  disease: '/inventory/disease',
  bodyLocation: '/inventory/body-location',
  usersAndLogs: '/users-and-logs',
  usersAndLogsUsers: '/users-and-logs/users',
  usersAndLogsLogs: '/users-and-logs/logs',
  usersAndLogsInvitations: '/users-and-logs/invitations',
  subjectBase: '/subject',
  subject: '/subject/:id',
  subjectSite: '/subject/:id/:siteId',
  subjectQueriesBase: '/subject/queries',
  subjectQueries: '/subject/queries/:id',
  subjectQuery: '/subject/queries/:id/query/:queryId',
  subjectQueriesSite: '/subject/queries/:id/:siteId',
  users: '/users',
  logs: '/logs',
  auditTrials: '/audit-trials',
  sponsorsAuditClinicalTrials: '/sponsors/audit-trails',
  sponsorsAuditClinicalTrial: '/sponsors/audit-trails/:id',
  // Clinical trial overview tabs
  clinicalTrialOverviewDashboard: '/clinical-trials/:id/overview/dashboard',
  clinicalTrialOverviewAuditTrails:
    '/clinical-trials/:id/overview/audit-trails',
  clinicalTrialOverviewEligibility: '/clinical-trials/:id/overview/eligibility',
  clinicalTrialOverviewStatistics: '/clinical-trials/:id/overview/statistics',
  clinicalTrialOverviewReadingsCompleted:
    '/clinical-trials/:id/overview/readings-completed',
  clinicalTrialOverviewUploads: '/clinical-trials/:id/overview/uploads',
  clinicalTrialOverviewQueries: '/clinical-trials/:id/overview/queries',
  clinicalTrialOverviewQuery: '/clinical-trials/:id/overview/queries/:queryId',
  clinicalTrialOverviewReports: '/clinical-trials/:id/overview/reports',
  readerClinicalTrial: '/reader/:id',
  readerClinicalTrialReadings: '/reader/:id/readings',
  readerTaskPage: '/reader/:id/:taskId',
  readerTaskViewer: '/reader/:id/:taskId/viewer',
  readerSubTaskViewer: '/reader/:id/:taskId/:subTaskId/viewer',
  readerTaskViewerDetached: '/reader/:id/:taskId/viewer-detached',
  readerSubTaskViewerDetached: '/reader/:id/:taskId/:subTaskId/viewer-detached',
  readerTaskPlain: '/reader/:id/:taskId/plain',
  sponsor: '/sponsor',
  sponsorPages: '/sponsor/:id',
  sponsorOverview: '/sponsor/:id/overview',
  sponsorEligibility: '/sponsor/:id/eligibility',
  sponsorStatistics: '/sponsor/:id/statistics',
  sponsorReadingsCompleted: '/sponsor/:id/readings-completed',
  sponsorUploads: '/sponsor/:id/uploads',
  sponsorQueries: '/sponsor/:id/queries',
  sponsorQuery: '/sponsor/:id/queries/:queryId',
  localhostScoringForm: '/localhost-scoring-form',
  clinicalTrialTaskViewer: '/clinical-trials/:id/:taskId/viewer',
  clinicalTrialSubTaskViewer: '/clinical-trials/:id/:taskId/:subTaskId/viewer',
  clinicalTrialTaskSimpleViewer: '/clinical-trials/:id/:taskId/viewer-simple',
  clinicalTrialTaskViewerDetached:
    '/clinical-trials/:id/:taskId/viewer-detached',
  clinicalTrialSubTaskViewerDetached:
    '/clinical-trials/:id/:taskId/:subTaskId/viewer-detached',
  clinicalTrialTaskPlain: '/clinical-trials/:id/:taskId/plain',
  sponsorTaskViewer: '/sponsor/:id/:taskId/viewer',
  sponsorTaskSimpleViewer: '/sponsor/:id/:taskId/viewer-simple',
  sponsorSubTaskViewer: '/sponsor/:id/:taskId/:subTaskId/viewer',
  sponsorTaskViewerDetached: '/sponsor/:id/:taskId/viewer-detached',
  sponsorSubTaskViewerDetached:
    '/sponsor/:id/:taskId/:subTaskId/viewer-detached',
  sponsorTaskPlain: '/sponsor/:id/:taskId/plain',
  clinicalTrialQcTaskViewer: '/clinical-trials/:id/:taskId/qc-viewer',
  // External User routes
  externalUserSubjects: '/ext-user/subjects',
  externalUserSubjectsClinicalTrial: '/ext-user/:clinicalTrialId/subjects',
  externalUserSubjectDetail: '/ext-user/subjects/:patientId',
  externalUserSubjectDetailClinicalTrial:
    '/ext-user/:clinicalTrialId/subjects/:patientId',
  externalUserTaskViewer: '/ext-user/:id/:taskId/viewer',
  externalUserSubTaskViewer: '/ext-user/:id/:taskId/:subTaskId/viewer',
  externalUserTaskViewerDetached: '/ext-user/:id/:taskId/viewer-detached',
  externalUserSubTaskViewerDetached:
    '/ext-user/:id/:taskId/:subTaskId/viewer-detached',
  externalUserTaskPlain: '/ext-user/:id/:taskId/plain',
  validationSpecialistSubjects: '/validation-specialist/subjects',
  validationSpecialistSubjectsClinicalTrial:
    '/validation-specialist/:clinicalTrialId/subjects',
  validationSpecialistSubjectDetail:
    '/validation-specialist/subjects/:patientId',
  validationSpecialistSubjectDetailClinicalTrial:
    '/validation-specialist/:clinicalTrialId/subjects/:patientId',
} as const;
